<template>
    <div class="slider" :style="{
    '--transition-duration': `${transition}ms`,
    '--direction': `${direction}`
    }">
        <template v-if="slider">
            <transition name="slide-animation--carousel">
                <slide :slide="currentSlideData" :key="currentSlide"></slide>
            </transition>
        </template>
        <div class="slider__controls">
            <div class="slider__controls__control" @click="prevSlide()">
                <chevron-left />
            </div>
            <div class="slider__controls__control" @click="nextSlide()">
                <chevron-right />
            </div>
        </div>
        <div class="slider__indicator">
            <div
              @click="setSlide(indicator - 1)"
              class="slider__indicator__dot"
              v-for="(indicator, index) in slideCount" :key="index"></div>
            <div
              :style="{transform: `translateX(${currentSlide*2}em)`}"
              class="slider__indicator__dot slider__indicator__dot--active"></div>
        </div>
    </div>
</template>

<script type="text/babel">
import chevronLeft from '@/assets/chevron_left.svg';
import chevronRight from '@/assets/chevron_right.svg';
import slide from './Slider/Slide.vue';

export default {
  data() {
    return {
      currentSlide: 0,
      direction: 1,
      transition: 750,
      autoplay: true,
      duration: 5000,
      $interval: null,
    };
  },
  components: {
    slide,
    chevronRight,
    chevronLeft,
  },
  watch: {
    autoplay(newVal) {
      if (newVal) this.startAutoplay();
      else this.stopAutoplay();
    },
  },
  computed: {
    currentSlideData() {
      return this.slider.slides[this.currentSlide];
    },
    slider() {
      return this.$store.getters.getSliders[0];
    },
    slideCount() {
      return (this.slider) ? this.slider.slides.length : 0;
    },
  },
  mounted() {
    if (this.autoplay) this.startAutoplay();
  },
  methods: {
    startAutoplay() {
      this.$interval = setInterval(() => {
        this.nextSlide();
      }, this.duration + this.transition);
    },
    stopAutoplay() {
      clearInterval(this.$interval);
    },
    setSlide(_slide) {
      this.direction = Math.sign(_slide - this.currentSlide);
      this.currentSlide = _slide;
      if (this.autoplay) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    },
    prevSlide() {
      if (this.currentSlide > 0) {
        this.setSlide(this.currentSlide - 1);
      } else {
        this.setSlide(this.slideCount - 1);
      }
    },
    nextSlide() {
      if (this.currentSlide < this.slideCount - 1) {
        this.setSlide(this.currentSlide + 1);
      } else {
        this.setSlide(0);
      }
    },
  },
};
</script>

<style lang="scss">
    .slide-animation--carousel {
        &-enter-active, &-leave-active {
            transition: opacity var(--transition-duration), transform var(--transition-duration);
        }
        &-enter, &-leave-to {
            /*opacity: 0;*/
        }
        &-enter {
            transform: translateX(calc(100% * var(--direction)));
        }
        &-leave-to {
            transform: translateX(calc(-100% * var(--direction)));
        }
    }

    .slider__controls {
        position: absolute;
        width: 100%;
        display: flex;
        justify-content: space-between;
        height: 100%;
        &__control {
            height: 100%;
            display: flex;
            align-items: center;
            svg {
                width: 64px;
                height: 64px;
                padding: 1em .25em;
                box-sizing: content-box;
                box-shadow: 0 2px 25px rgba(0, 0, 0, 0.2), 0 5px 10px rgba(0, 0, 0, 0.2);
                background: #fff;
                border-radius: 0 4px 4px 0;
            }
            &:last-of-type {
                svg {
                    border-radius: 4px 0 0 4px;
                }
            }
        }
    }
    .slider__indicator {
        position: absolute;
        bottom: .5em;
        display: flex;
        justify-content: center;
        left: 50%;
        transform: translateX(-50%);
        &__dot {
            width: 1em;
            height: 1em;
            border-radius: .5em;
            border: solid 2px rgba(255, 255, 255, 0.18);
            margin: 0 0.5em;
            &--active {
                position: absolute;
                left: 0;
                background: var(--accent-color);
                transition: transform var(--transition-duration);
            }
        }
    }
</style>
